import { Component} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ProductOption } from 'src/app/assabil-kernel/models/entities/master-data/product-option-entity';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';


@Component({
    selector: 'product-product-option-widget',
    templateUrl: './product-product-option-widget.component.html',
    styleUrls: ['./product-product-option-widget.component.scss']
})

export class ProductProductOptionWidgetComponent extends BaseWidget {

    productOption: ProductOption = new ProductOption();

    constructor(
        protected masterDataService : MasterDataService, 
        protected toastr            : ToastrService,
        protected leanUtilsService  : LeanUtilsService) {
          super(toastr, leanUtilsService);
      }


    //------------------------------------------------------
    setEntity(productOption: ProductOption) {
        this.productOption = { ...productOption };
    }    
    getEntity(){
      return this.productOption;
    }    
    //------------------------------------------------------

    //------------------------------------------------------
    saveRow() : Promise<ProductOption>{
        return this.masterDataService.productOptionSave(this.productOption);
    }
    //------------------------------------------------------


    onSelectProductOption() { }
}
